module.exports = __webpack_public_path__ + "static/media/brandBritishLibrary.92312e81.jpg";